/**
 * Hexadecimal, string-formed color-code collection.
 * NOTE: Color objects ought not be complex and so must not be nested.
 */
export enum Color {
	/** Theme-colors */
	GRAY_1 = '#4E4F52',
	GRAY_2 = '#686868',
	GRAY_3 = '#9D9D9D',
	GRAY_4 = '#272727',
	BLACK_1 = '#000000',
	BLACK_2 = '#0A0A08',
	BLACK_3 = '#131313',
	BLACK_4 = '#1D1D1D',
	WHITE_1 = '#F1F3F6',
	WHITE_2 = '#F6F7F9',
	HASHUP = '#FF3F3F',
	HASHUP_2 = '#CD2323',
	GREEN_1 = '#6AAD38',

	/** Theme-color-detailing */
	HASHUP_BLACK = '#0A0A08',
	BACKGROUND_LIGHT = '#F6F7F8',
	BACKGROUND_DARK = '#252525',
	FORM_BACKGROUND = '#171717',
	FROM_BORDER = '#4E4F52',
	TEXT_BLACK = '#000000',
	TEXT_BLACK_LIGHT = '#21242B',
	TEXT_WHITE = '#FFFFFF',
	TEXT_GRAY_LIGHT = '#6D6D6D',
	TEXT_GRAY = '#646E83',
	GRAPH_GREEN = '#6AAD38',
	GRAPH_RED = HASHUP,
	BORDER = '#FFFFFFF1A',
	BORDER_TABLE_LIGHT = '#F1F3F6',
	SHADOW = '#0000000D',
	CARD_BORDER = '#F0F2F5',
}
